import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-576829dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "juou-card statistics" }
const _hoisted_3 = { class: "statistics-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "累计设备数量", -1))
const _hoisted_5 = { class: "number" }
const _hoisted_6 = { class: "statistics-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "在线设备", -1))
const _hoisted_8 = { class: "number" }
const _hoisted_9 = { class: "statistics-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "累计扫码次数", -1))
const _hoisted_11 = { class: "number" }
const _hoisted_12 = { class: "statistics-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "累计扫码人数", -1))
const _hoisted_14 = { class: "number" }
const _hoisted_15 = {
  class: "juou-card message",
  style: {"margin-top":"8px"}
}
const _hoisted_16 = { class: "title" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "站内信", -1))
const _hoisted_18 = { class: "list" }
const _hoisted_19 = { class: "time" }

import {
  JuouProTable,
  JuouProTableColumn,
  JuouProTableData,
  JuouProTableFilter,
  JuouProTableGetDataFunction,
  JuouDangerDialog,
  useBaseAsync,
  JuouProForm,
  JuouProFormItem,
  useBaseOperateStore,
} from 'juou-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ElMessage, ElMessageBox } from 'element-plus';
import { ref } from 'vue';
import dayjs from 'dayjs';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const columns = ref<JuouProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof JuouProTable>>();
const baseOperateStore = useBaseOperateStore();

const statistics = ref({
  onlineDevice: 0,
  totalCount: 0,
  totalDevice: 0,
  totalPeople: 0,
});

const messages = ref<any[]>([]);


const messageItems = ref<JuouProFormItem[]>([
  {
    name: 'msg',
    label: '内容',
    rule: [{ required: true }],
    type: 'textaera',
  },
]);

const sendMsgForm = ref<InstanceType<typeof JuouProForm>>();

const statisticLoading = ref(false);

const getStatistics = useBaseAsync(async() => {
  try {
    statisticLoading.value = true;
    const res = await useApi().homeApi.getHomeStatisticshome();
    console.log(res);
    statistics.value = res.data.data;
  } finally {
    statisticLoading.value = false;
  }
});

const messageLoading = ref(false);
const getMessage = useBaseAsync(async() => {
  try {
    messageLoading.value = true;
    const res = await useApi().homeApi.listMessagehome({ conditions: {} });
    console.log(res);
    messages.value = res.data.data;
  } finally {
    messageLoading.value = false;
  }
});

const refreash = () => {
  getStatistics();
  getMessage();
};

const handleSendMsg = async(row: any) => {
  messageLoading.value = true;
  await useApi().homeApi.addMessagehome({ messageAdminVo: row });
  ElMessage.success('发送成功');
  refreash();
};

const deleteAction = async(msgId: number) => {
  await useApi().homeApi.delMessagehome(msgId);
  ElMessage.success('删除成功');
  refreash();
};

const handleDeleteMsg = (msgId: number) => {
  ElMessageBox.confirm('删除后无法恢复，确定要删除吗？', '删除', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
  }).then(() => {
    deleteAction(msgId);
  });
};

const handleClickSend = () => {
  sendMsgForm.value?.reset();
  sendMsgForm.value?.showDialog();
};


refreash();

// init();


return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", null, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(statistics.value.totalDevice), 1),
          _createTextVNode("台 ")
        ])
      ]),
      _createVNode(_component_el_divider, { direction: "vertical" }),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", null, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(statistics.value.onlineDevice), 1),
          _createTextVNode("台 ")
        ])
      ]),
      _createVNode(_component_el_divider, { direction: "vertical" }),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("span", null, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(statistics.value.totalCount), 1),
          _createTextVNode("次 ")
        ])
      ]),
      _createVNode(_component_el_divider, { direction: "vertical" }),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("span", null, [
          _createElementVNode("span", _hoisted_14, _toDisplayString(statistics.value.totalPeople), 1),
          _createTextVNode("人 ")
        ])
      ])
    ])), [
      [_directive_loading, statisticLoading.value]
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        (_unref(baseOperateStore).operates?.find(item => item.key === 'SEND_MESSAGE'))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              link: "",
              type: "danger",
              style: {"color":"red"},
              onClick: handleClickSend
            }, {
              default: _withCtx(() => [
                _createTextVNode("发送")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (msg) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "list-item",
            key: msg.id
          }, [
            _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(dayjs)(msg.createTime).format("YYYY/MM/DD")), 1),
            _createElementVNode("span", null, _toDisplayString(msg.msg), 1),
            (_unref(baseOperateStore).operates?.find(item => item.key === 'DEL_MESSAGE'))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  link: "",
                  type: "danger",
                  style: {"color":"red"},
                  onClick: () => handleDeleteMsg(msg.id)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除")
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])), [
      [_directive_loading, messageLoading.value]
    ]),
    _createVNode(_unref(JuouProForm), {
      ref_key: "sendMsgForm",
      ref: sendMsgForm,
      title: "发送站内信",
      items: messageItems.value,
      "is-dialog": "",
      onOk: handleSendMsg
    }, null, 8, ["items"])
  ]))
}
}

})